const MODULE_NAME = "oncall/";

//users list
export const USERS_PAGE_LOAD = `@@${MODULE_NAME}USERS_PAGE_LOAD`;
export const USERS_LOADED = `@@${MODULE_NAME}USERS_LOADED`;

//edit user
export const USER_PAGE_LOAD = `@@${MODULE_NAME}USER_PAGE_LOAD`;
export const USER_PAGE_LOADED = `@@${MODULE_NAME}USER_PAGE_LOADED`;
export const USER_ADD_REQUEST = `@@${MODULE_NAME}USER_ADD_REQUEST`;
export const USER_USERNAME_CHANGE_REQUEST = `@@${MODULE_NAME}USER_USERNAME_CHANGE_REQUEST`;
export const USER_PASSWORD_CHANGE_REQUEST = `@@${MODULE_NAME}USER_PASSWORD_CHANGE_REQUEST`;
export const USER_ENABLE_REQUEST = `@@${MODULE_NAME}USER_ENABLE_REQUEST`;
export const USER_DISABLE_REQUEST = `@@${MODULE_NAME}USER_DISABLE_REQUEST`;
export const USER_ADD_ERROR = `@@${MODULE_NAME}USER_ADD_ERROR`;
export const USER_USERNAME_CHANGE_ERROR = `@@${MODULE_NAME}USER_USERNAME_CHANGE_ERROR`;
export const USER_PASSWORD_CHANGE_ERROR = `@@${MODULE_NAME}USER_PASSWORD_CHANGE_ERROR`;
export const USER_ENABLE_ERROR = `@@${MODULE_NAME}USER_ENABLE_ERROR`;
export const USER_DISABLE_ERROR = `@@${MODULE_NAME}USER_DISABLE_ERROR`;
export const USER_USERNAME_CHANGED = `@@${MODULE_NAME}USER_USERNAME_CHANGED`;
export const USER_PASSWORD_CHANGED = `@@${MODULE_NAME}USER_PASSWORD_CHANGED`;
export const USER_ENABLED = `@@${MODULE_NAME}USER_ENABLED`;
export const USER_DISABLED = `@@${MODULE_NAME}USER_DISABLED`;

export const usersPageLoad = () => ({
  type: USERS_PAGE_LOAD,
  payload: {},
});

export const usersLoaded = users => ({
  type: USERS_LOADED,
  payload: {
    users,
  },
});

export const userPageLoad = username => ({
  type: USER_PAGE_LOAD,
  payload: { username },
});

export const userPageLoaded = user => ({
  type: USER_PAGE_LOADED,
  payload: {
    user,
  },
});

export const userAddRequest = (formData, partnerId) => ({
  type: USER_ADD_REQUEST,
  payload: {
    formData,
    partnerId,
  },
});

export const userUsernameChangeRequest = (username, newUsername) => ({
  type: USER_USERNAME_CHANGE_REQUEST,
  payload: {
    username,
    newUsername,
  },
});

export const userPasswordChangeRequest = (username, password) => ({
  type: USER_PASSWORD_CHANGE_REQUEST,
  payload: {
    username,
    password,
  },
});

export const userEnableRequest = username => ({
  type: USER_ENABLE_REQUEST,
  payload: {
    username,
  },
});

export const userDisableRequest = username => ({
  type: USER_DISABLE_REQUEST,
  payload: {
    username,
  },
});

export const userAddError = message => ({
  type: USER_ADD_ERROR,
  payload: {
    message,
  },
});

export const userUsernameChangeError = message => ({
  type: USER_USERNAME_CHANGE_ERROR,
  payload: {
    message,
  },
});

export const userPasswordChangeError = message => ({
  type: USER_PASSWORD_CHANGE_ERROR,
  payload: {
    message,
  },
});

export const userEnableError = message => ({
  type: USER_ENABLE_ERROR,
  payload: {
    message,
  },
});

export const userDisableError = message => ({
  type: USER_DISABLE_ERROR,
  payload: {
    message,
  },
});

export const userUsernameChanged = username => ({
  type: USER_USERNAME_CHANGED,
  payload: {
    username,
  },
});

export const userPasswordChanged = () => ({
  type: USER_PASSWORD_CHANGED,
  payload: {},
});

export const userEnabled = () => ({
  type: USER_ENABLED,
  payload: {},
});

export const userDisabled = () => ({
  type: USER_DISABLED,
  payload: {},
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/actions/users.js